<template>

    <v-dialog
      v-model="$store.state.dialogClienteGeneral"
      max-width="500"
      >
          <div>
      <v-system-bar window dark>
        <v-icon @click="$store.commit('dialogClienteGeneral')">mdi-close</v-icon>
      </v-system-bar>
    </div>
      <v-card>
          <v-form
              ref="form"
              class="pa-3"
              v-model="valid"
              lazy-validation
            >
              <v-row class="mt-n1">
                <v-col cols="6" xs="6">
              <v-text-field
                class="mt-n2"
                v-model="clienteuno.dni"
                :counter="8"
                :rules="dniRules"
                label="Dni"
                :disabled="activo"
                required
              ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6">
              <v-text-field
                class="mt-n2"
                v-model="clienteuno.ruc"
                label="RUC"
                required
              ></v-text-field>
                </v-col>
              </v-row>


              <v-text-field
                class="mt-n5"
                v-model="clienteuno.nombreCompleto"
                :counter="30"
                :rules="nameRules"
                label="Nombres Completos"
                required
              ></v-text-field>

              
               <v-row class="mt-n1">
                <v-col cols="6" xs="6">
              <v-text-field
                class="mt-n3"
                v-model="clienteuno.celular"
                :counter="10"
                :rules="cellRules"
                label="Celular"
                required
              ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6">
                <v-text-field
                class="mt-n3"
                      @click="modal=!modal"
                      v-model="date"
                      label="Fecha nacimiento"
                      readonly
                      v-on="on"
                    ></v-text-field>
                </v-col>
               </v-row>


              <v-text-field
                class="mt-n3"
                v-model="clienteuno.correo"
                label="E-mail (Opcional)"
              ></v-text-field> 
            <v-row class="mt-n5">
              <v-col cols="6" xs="6">
                  <v-select
                v-model="clienteuno.departamento"
                 :rules="depaRules"
                class="mb-3"
                :items="departamentos"
                menu-props="auto"
                hide-details
                label="Departamento"
                ></v-select>
              </v-col>
              <v-col cols="6" xs="6">
              <v-text-field
                v-model="clienteuno.provincia"
                :counter="8"
                :rules="depaRules"
                label="Provincia"
                required
              ></v-text-field>
              </v-col>
              </v-row>

              <v-text-field
                class="mt-n5"
                v-model="clienteuno.distrito"
                :counter="8"
                :rules="depaRules"
                label="Distrito"
                required
              ></v-text-field>

            <v-text-field
                class="mt-n3"
                v-model="clienteuno.direccion"
                :counter="8"
                :rules="depaRules"
                label="Direccion(Urb/Calle/Mz/Lt/Nº)"
                required
              ></v-text-field>
              
            <v-text-field
                class="mt-n3"
                v-model="clienteuno.referencia"
                :counter="8"
                :rules="depaRules"
                label="Referencia"
                required
              ></v-text-field>
            </v-form>
        <v-card-actions class="mt-n5">
          <v-btn
          :disabled="!valid"
            color="success"
            class="mr-4"
            @click.stop="agregar"
          >
            Guardar
          </v-btn>

          <v-btn
            color="error"
            text
             @click.stop="eliminar()"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>

   <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <v-date-picker v-model="date"  scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>

    </v-dialog>
</template>

<script>
import { db } from '../db'
import cuerpoprincipal from '@/components/cuerpoprincipal'
import mensajeCard from '@/components/mensajeCard'
import store from '@/store/index'

  export default {
    name: 'dialogClienteGeneral',
    props:[
        'clienteuno',
        'activo'
    ],

    data() {
        return {
        modal:false,
        date: new Date().toISOString().substr(0, 10),
        cliente:[],
        clienteuno:{},
        valid: true,
        dni: '',
        dniRules: [
        v => !!v || 'Dni is required',
        v => (v && v.length == 8) || 'Name must be less than 8 characters',
      ],
    depaRules: [
        v => !!v || 'required',
        v => (v && v.length > 0) || 'no puede ser vacio',
      ],
        name: '',
        nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 10 characters',
      ],
        cell: '',
        cellRules: [
        v => !!v || 'Cell is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
        email: '',
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
          productos: [],
          categorias: [],
          departamentos:[
                  'Amazonas',
                  'Áncash',
                  'Apurímac',
                  'Arequipa',
                  'Ayacucho',
                  'Cajamarca',
                  'Cusco',
                  'Huancavelica',
                  'Huánuco',
                  'Ica',
                  'Junín',
                  'La Libertad',
                  'Lambayeque',
                  'Lima',
                  'Loreto',
                  'Moquegua',
                  'Piura',
                  'Puno',
                  'San Martín',
                  'Tacna',
                  'Tumbes',
                  'Ucayali',
        ]
        } 
      },
       methods: {
        agregar(){
                this.$refs.form.validate()
            if(this.clienteuno.dni!="" && this.clienteuno.nombreCompleto!="" && this.clienteuno.celular!="" ){
              db.database().ref("cliente").child(this.clienteuno.dni).set({
                    dni:this.clienteuno.dni,
                    nombreCompleto:this.clienteuno.nombreCompleto,
                    celular:this.clienteuno.celular,
                    correo:this.clienteuno.correo,
                    departamento:'La Libertad',
                    provincia:'Trujillo',
                    distrito:this.clienteuno.distrito,
                    direccion:this.clienteuno.direccion,
                    referencia:this.clienteuno.referencia
                    })
                    this.clienteuno.dni=""
                    this.clienteuno.nombreCompleto=""
                    this.clienteuno.celular=""
                    this.clienteuno.correo=""
                    this.clienteuno.distrito=""
                    this.clienteuno.direccion=""
                    this.clienteuno.referencia=""
                store.commit('dialogClienteGeneral')
            }
        },
        eliminar(){
            if(this.clienteuno.dni!="" ){
              db.database().ref("cliente").child(this.clienteuno.dni).remove()
               store.commit('dialogClienteGeneral')
            }
        },

        validate () {
            this.$refs.form.validate()
        },
   
    },


  }
</script>